function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 .39v17.22L.834 9 6 .39zM2 9l3-5v10L2 9z",
  fill: "#1722A2"
});

function SvgTriangleBorder(props) {
  return React.createElement("svg", _extends({
    width: 6,
    height: 17,
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNiIgaGVpZ2h0PSIxNyIgdmlld0JveD0iMCAwIDYgMTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNi4wMDAxNyAwLjM4OTY0OFYxNy42MTAzTDAuODMzOTg0IDguOTk5OTdMNi4wMDAxNyAwLjM4OTY0OFpNMi4wMDAxNyA4Ljk5OTk3TDUuMDAwMTcgMy45OTk5N1YxNEwyLjAwMDE3IDguOTk5OTdaIiBmaWxsPSIjMTcyMkEyIi8+Cjwvc3ZnPgo=";
export { SvgTriangleBorder as ReactComponent };